/**
 * Camp Center Management Slice
 * @format
 */

import { createAction, createSlice } from "@reduxjs/toolkit";

const initialState = {
  allCampCentersList: {},
  campCenter: {},
  allStateWithCampCenterCount: [],
  currentPage: 1,
  respPerPage: 10,
  stateId: "",
  campCenterSearchQuery: "",
};

const campCenterManagementSlice = createSlice({
  name: "campCenterManagement",
  initialState,
  reducers: {
    setAllCampCenterList(state, action) {
      state.allCampCentersList = action.payload;
    },
    setCampCenter(state, action) {
      state.campCenter = action.payload;
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    setRespPerPage(state, action) {
      state.respPerPage = action.payload;
    },
    setAllStateWithCampCenterCount(state, action) {
      state.allStateWithCampCenterCount = action.payload;
    },
    setStateId(state, action) {
      state.stateId = action.payload;
    },
    setCampCenterSearchQuery(state, action) {
      state.campCenterSearchQuery = action.payload;
    },
  },
});

// Reducer
export const campCenterManagementReducer = campCenterManagementSlice.reducer;

// Actions
export const {
  setAllCampCenterList,
  setCampCenter,
  setCurrentPage,
  setRespPerPage,
  setAllStateWithCampCenterCount,
  setStateId,
  setCampCenterSearchQuery,
} = campCenterManagementSlice.actions;

export const allCampCenterList = createAction("ALLCAMPCENTERLIST");
export const createCampCenter = createAction("CREATENEWCAMPCENTER");
export const updateCampCenterById = createAction("UPDATECAMPCENTERBYID");
export const getCampCenterById = createAction("GETCAMPCENTERBYID");
export const deleteCampCenter = createAction("DELETECAMPCENTER");
export const updateCampCenterStatusById = createAction(
  "UPDATECAMPCENTERSTATUSBYID"
);
export const getAllStateWithCampCenterCount = createAction(
  "ALLSTATUSWITHCAMPCENTERCOUNT"
);
